var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgElevenLogoFooter = function SvgElevenLogoFooter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127,
    height: 29,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#elevenLogoFooter_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.521 10.534H42.06v3.011h5.727v1.822H42.06v3.106h6.537v1.813h-8.547V8.71h8.472v1.823M55.544 8.713h2.014v9.727h6.004v1.85h-8.02V8.714zM78.388 10.534h-6.462v3.011h5.727v1.822h-5.727v3.106h6.544v1.813h-8.555V8.71h8.473v1.823M93.54 8.674h2.173l-4.745 11.654h-1.76L84.454 8.674h2.226l3.437 8.895zM109.987 10.534h-6.462v3.011h5.731v1.822h-5.731v3.106h6.548v1.813h-8.549V8.71h8.462v1.822zM125.028 8.713H127v11.575h-1.676l-6.294-8.219v8.219h-1.98V8.713h1.862l6.116 8.014zM21.797 21.418l6.827-6.915-6.535-6.626zM16.189 1.899 14.313 0 0 14.503l5.573 5.643zM19.397 5.15 17.49 3.22l-7.145 21.76L14.313 29l1.451-1.467z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "elevenLogoFooter_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h127v29H0z"
  })))));
};
export default SvgElevenLogoFooter;